module.exports = __webpack_public_path__ + "img/only-man.98d0f458.svg";